module.exports = __webpack_public_path__ + "fonts/SpareBank1-BoldIt-Web.a097e0d.woff";